import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { useScheduleDrawerStore } from '~/stores/use-schedule-drawer-store/useScheduleDrawerStore';
import type { WebSearch } from '~/views/alfred/research/services/conversations-service';

export const useScheduleDrawerUrlSync = () => {
  const { params, setQueryParams, deleteQueryParam } = useQueryParams();
  const { storeOpen, storeClose, storeOpenForEdit } = useScheduleDrawerStore(
    state => ({
      storeOpen: state.open,
      storeClose: state.close,
      storeOpenForEdit: state.openForEdit,
    })
  );

  const isOpen =
    params[queryKeys.activeDrawer] === queryValues.scheduleQueryDrawer;

  const open = (query?: string, priorWebSearch?: WebSearch) => {
    storeOpen(query, priorWebSearch);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.scheduleQueryDrawer,
    });
  };

  const openForEdit = (taskId: string) => {
    storeOpenForEdit(taskId);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.scheduleQueryDrawer,
    });
  };

  const close = () => {
    storeClose();
    deleteQueryParam(queryKeys.activeDrawer, { replace: true });
  };

  return { isOpen, open, openForEdit, close };
};
